import React from 'react';
import { Flex, Title, Text, withPadding } from 'sg-styleguide';

import { FlexWithPadding, localize } from '../../components/helpers';

const StepDescription = (props) => {
	return(
		<FlexWithPadding
			padding={props.isPhone ? ['none', 'none', 'large', 'none'] : ['none', 'large', 'large', 'large']}
			direction="column"
		>
			<Title
				level="1"
				density="cozy"
				weight="light"
				color="dark"
				align="center"
			>
				{localize( props.title )}
			</Title>
			<Text
				size="medium"
				align="center"
			>
				{localize( props.subtitle )}
			</Text>
		</FlexWithPadding>
	);
}

export default StepDescription;